





















































































































import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import DatePicker from '../common/DatePicker.vue';

import {
  EmployeeFormFieldSubmission,
  FormFieldTypeEnum,
  EmployeeFormSubmission,
  EmployeeFormSubmissionStateEnum,
  IFormSectionFieldData,
  IEmployeeFormFieldOptionSubmissionData,
  IEmployeeFormFieldSubmissionData,
  IFormSectionData,
  IEmployeeFormSectionSubmissionData,
  IEmployeeFormSectionSubmissionFieldErrorData,
  IEmployeeFormSubmission,
  IEmployeeFormSubmissionData,
  IFormTemplateData,
  FormTemplate,
  IFormFieldData
} from '@/models';
import { ErrorManager } from '@/models/error';

import { AxiosError } from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { diffDeep } from '@/utils/helpers';
import { cloneDeep } from 'lodash';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import EmployeeFormSubmissionFields from './EmployeeFormSubmissionFields.vue';
import { IUpdateEmployeeFormSubmissionStatePayload } from '@/services';

export default mixins(auth).extend({
  components: {
    ALDialog,
    ErrorAlert,
    DatePicker,
    EmployeeFormSubmissionFields
  },

  data() {
    return {
      FormFieldTypeEnum,

      dialog: false,
      loading: false,
      isEdit: false,
      isPreview: false,

      sectionPosition: 1,

      errorMessage: '',
      detailErrorMessage: '',

      fieldError: [] as IEmployeeFormSectionSubmissionFieldErrorData[],

      formTemplate: {} as IFormTemplateData,
      formSubmission: {} as IEmployeeFormSubmissionData,

      answers: [] as IEmployeeFormSectionSubmissionData[]
    };
  },

  computed: {
    ...mapGetters({
      getFormTemplateById: 'formTemplate/getFormTemplateById',
      getEmployeeFormSubmissionById:
        'employeeForm/getEmployeeFormSubmissionById'
    }),

    isFormSingleSection(): boolean {
      return this.dialog && this.formTemplate.sections!.length <= 1;
    },

    canSaveAsDraft(): boolean {
      return this.formSubmission.state == EmployeeFormSubmissionStateEnum.Draft;
    }
  },

  methods: {
    ...mapActions({
      updateEmployeeFormSubmissionState:
        'employeeForm/updateEmployeeFormSubmissionState',
      createEmployeeFormSubmission: 'employeeForm/createEmployeeFormSubmission',
      updateEmployeeFormSubmission: 'employeeForm/updateEmployeeFormSubmission',
      fetchEmployeeFormSubmission: 'employeeForm/fetchEmployeeFormSubmission'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
      this.fieldError = [] as IEmployeeFormSectionSubmissionFieldErrorData[];
    },

    open(
      template: IFormTemplateData,
      submission?: IEmployeeFormSubmission,
      preview = false
    ) {
      this.clearAllErrors();

      this.isPreview = preview;

      this.formTemplate = new FormTemplate(template);

      if (submission) {
        this.formSubmission = new EmployeeFormSubmission(submission);
      } else {
        //create default instance
        this.formSubmission = new EmployeeFormSubmission({
          form: {} as IFormTemplateData
        });
      }

      this.answers = this.genFormAnswers(this.formTemplate.sections!);

      this.isEdit = !!submission;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.sectionPosition = 1;
    },

    genFormAnswers(
      sections: IFormSectionData[]
    ): IEmployeeFormSectionSubmissionData[] {
      const answers = [] as IEmployeeFormSectionSubmissionData[];

      sections.forEach((section, i) => {
        answers.push({ fields: [] as IEmployeeFormFieldSubmissionData[] });

        section.section_fields!.forEach(section_field => {
          let answer = this.formSubmission.answers?.find(
            data => (data.field as IFormSectionFieldData).id == section_field.id
          );

          if (!answer) {
            answer = new EmployeeFormFieldSubmission({
              value: '',
              field: section_field.id!,
              option_submissions: [] as IEmployeeFormFieldOptionSubmissionData[]
            });
          } else if (
            (section_field.field_template as IFormFieldData).type ==
            FormFieldTypeEnum.Checkbox
          ) {
            //TODO: MG- 24-03-2022: Look into why checklist with calue object causes bug
            answer.option_submissions = (answer.option_submissions as IEmployeeFormFieldOptionSubmissionData[]).map(
              (data: IEmployeeFormFieldOptionSubmissionData) => data.option
            );
          }

          answers[i].fields.push(answer);
        });
      });

      return answers;
    },

    //this moves the form to the first section that has an error
    genFieldErrorSectionPosition(): number {
      let sectionPosition = 0;

      this.fieldError.forEach((section, i) => {
        if (!sectionPosition) {
          section.errors.forEach(error => {
            if (error) {
              sectionPosition = i + 1;
              return;
            }
          });
        } else {
          return;
        }
      });

      return sectionPosition;
    },

    async updateFormSubmissionData() {
      let answerPayload = [] as IEmployeeFormFieldSubmissionData[];

      let originalFormSubmission = {} as IEmployeeFormSubmissionData;

      let edittingForm = false;

      if (this.isEdit || this.formSubmission.id) {
        edittingForm = true;
      }

      if (edittingForm) {
        originalFormSubmission = await this.getEmployeeFormSubmissionById(
          this.formSubmission.id!
        );
      }

      this.answers.forEach((answer, i) => {
        answerPayload = answerPayload.concat(
          answer.fields.map(submission => {
            //this code fixes the bug where a user clears a vselect
            const nullFilterOptions = (submission.option_submissions as IEmployeeFormFieldOptionSubmissionData[]).filter(
              option => option != null
            );

            const options = (nullFilterOptions as IEmployeeFormFieldOptionSubmissionData[]).map(
              (option: IEmployeeFormFieldOptionSubmissionData | number, i) => {
                if (typeof option == 'number') {
                  if (edittingForm) {
                    const org_submission = originalFormSubmission.answers!.find(
                      org =>
                        (org.field as IFormSectionFieldData).id ==
                        (submission.field as IFormSectionFieldData).id
                    );

                    if (org_submission) {
                      const org_option = (org_submission.option_submissions as IEmployeeFormFieldOptionSubmissionData[]).find(
                        org_option => org_option.option == option
                      );

                      if (org_option) {
                        return org_option;
                      }
                    }
                  }

                  return { option: option };
                }
                return option;
              }
            );

            return { ...submission, option_submissions: options };
          })
        );
      });

      //when updating form the id of the created answer fields form will need to be
      //correctly mapped to the answerpayload in order to prevent a unique constraint failure
      //of the server
      if (edittingForm) {
        answerPayload = answerPayload.map((submission, i) => {
          const originalSubmissionAnswer = originalFormSubmission.answers!.find(
            answer =>
              (answer.field as IFormSectionFieldData).id == submission.field
          );

          if (!originalSubmissionAnswer) {
            return submission;
          }

          return { ...submission, id: originalSubmissionAnswer.id };
        });
      }

      this.formSubmission = new EmployeeFormSubmission({
        ...this.formSubmission,
        form: this.formTemplate.id!,
        answers: answerPayload
      });
    },

    async save() {
      await this.updateFormSubmissionData();

      const formSubmissionPayload = cloneDeep(this.formSubmission);
      if (this.isEdit || this.formSubmission.id) {
        const originalFormSubmission = await this.getEmployeeFormSubmissionById(
          formSubmissionPayload.id!
        );

        const formSubmissionDelta = diffDeep(
          this.formSubmission,
          originalFormSubmission,
          true
        );

        await this.updateEmployeeFormSubmission(formSubmissionDelta);
      } else {
        this.formSubmission.owner = this.currentUser.id;
        const submissionId = await this.createEmployeeFormSubmission(
          this.formSubmission
        );

        //update form submission and answers with saved data coming from server.
        this.formSubmission = this.getEmployeeFormSubmissionById(submissionId);
        this.answers = this.genFormAnswers(this.formTemplate.sections!);
      }

      //fetch updated checklist and department list from server
      this.$emit('refreshChecklist');
    },

    async submitForm() {
      this.loading = true;
      try {
        await this.save();

        if (
          this.formSubmission.state == EmployeeFormSubmissionStateEnum.Draft
        ) {
          const payload = {
            id: this.formSubmission.id,
            state: EmployeeFormSubmissionStateEnum.InReview
          } as IUpdateEmployeeFormSubmissionStatePayload;

          await this.updateEmployeeFormSubmissionState(payload);
        }

        this.loading = false;
        this.close();
      } catch (err) {
        this.loading = false;
        const error = err as AxiosError;
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }

          // Form Model is dynamic and the server returns a diiferent model format for its error
          // therefore I have to map the error data to its correct field.
          if (error.response.data.answers) {
            const submissionFieldErrors = [] as IEmployeeFormSectionSubmissionFieldErrorData[];

            let index = 0;

            this.formTemplate.sections?.forEach((section, n) => {
              submissionFieldErrors.push({ errors: [] });

              section.section_fields?.forEach(field => {
                submissionFieldErrors[n].errors.push(
                  error.response!.data.answers[index].detail ?? ''
                );
                index++;
              });
            });

            this.fieldError = submissionFieldErrors;
            this.sectionPosition = this.genFieldErrorSectionPosition();
          }
        }

        this.errorMessage = ErrorManager.extractApiError(error);
      }
    },

    async saveDraftForm() {
      this.clearAllErrors();
      this.loading = true;

      try {
        await this.save();

        this.loading = false;
        this.close();
      } catch (err) {
        this.loading = false;
        const error = err as AxiosError;
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        }

        this.errorMessage = ErrorManager.extractApiError(error);
      }
    }
  }
});
